import React from "react";
import {
    Container,
    Header,
    Image,
    Button

} from "semantic-ui-react";

import DesignerImage from '../../../../images/grafix-banner/No-Initiatives-Graphics.svg';

class LandingPage extends React.Component {
    createInit() {
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/selectPlaybook'
        });
    }

    render() {

        return (
            <Container fluid className="pad_40" >
                <Header as='h2' icon textAlign='center' >
                    <Header.Content>
                        Initiative
                    </Header.Content>
                </Header><br />
                {this.props.initiativeCount === 0 ?
                    <div>
                        <p>You do not have any initiatives created so far. Its an easy process. </p>
                        <Image style={{ height: "320px" }} src={DesignerImage} className="landingImage" centered={true} />
                        <p>Click to create your own initiative &nbsp; &nbsp; <Button color="blue" onClick={() => this.createInit()}>Create Initiative</Button> </p>
                    </div> :
                    <div>
                        <Header as='h3' icon textAlign='center'>
                            <Header.Content >
                                <Image style={{ height: "320px" }} src={DesignerImage} className="landingImage" centered={true} />
                                <br /><br />
                                {this.props.noDataContent}
                            </Header.Content>
                        </Header>
                    </div>
                }
            </Container>
        );
    }
}
export default LandingPage;
